module.exports = __webpack_public_path__ + "fa-solid-900.svg?7a5de9b08012e4da40504f2cf126a351";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-solid-900.svg
// module id = 56
// module chunks = 0